<div class="tab-content-container mt-3 mb-2">
    <h4 class="border-bottom">Links</h4>
    @if (gridConfig) {
    <div class="links-tab-grid" [style.height.px]="gridHeight">
        <inavista-grid #linksTabGrid class="so-popup-grid"
            [config]="gridConfig"
            (hyperlinkClick)="onHyperlinkClick($event)"
            (exportRequested)="onExportRequested()" />
    </div>
    }
</div>

@if (showPartsOrderPopup) {
<app-parts-orders-popup 
   
    [id]="partsOrderId"
    [itemsData]="itemsData"
    [serviceOrderId]="serviceOrderId"
    [data]="partsOrderData"
    tab="details"
    popupSource="ServiceOrder"
    [serviceOrderTechnician]="{technicianName: $safeNavigationMigration(data?.technicianName), technicianId: $safeNavigationMigration(data?.technicianId)}"
    [showComments]="false"
    (onSave)="partsOrderClose()"
    (onClose)="partsOrderPopupClose()"
></app-parts-orders-popup>
}